module.exports = __webpack_public_path__ + "static/media/pt_receive_proposal.45b3097d.svg";